<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card>      

      <b-row>
        <b-col cols="12" sm="12" md="12" lg="6" xl="6">
          <b-row>
            <b-col cols="12">
              <b-card-title class="fs-32 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span> {{ name }} </span>
                </div>
              </b-card-title> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="d-flex align-items-center">
              <label class="fs-20">Deseja habilitar esse meio de pagamento?</label>
              <b-form-checkbox
                switch
                class="ml-3"
                @change="paymentEnable()" 
                :checked="swicthMethodPayment"
                :disabled="isDisabled"
              />
              <span> {{ swicthMethodPayment ? 'Ativado' : 'Desativado' }}</span>
            </b-col>
          </b-row>

          <!-- DESCONTO -->
          <b-row class="mt-1 container">
            <label class="fs-20">Deseja habilitar desconto?</label>
            <b-form-checkbox
              switch
              class="ml-3"
              :checked="swicthDiscount"
              @change="discountEnable()"
            />
            <b-col cols="12" md="8" v-if="swicthDiscount">
              <div class="input-group mb-3" v-if="swicthMethodPayment">
                <input
                  v-if="swicthDiscount && swicthMethodPayment"
                  class="form-control"
                  placeholder="Ex: 10"
                  aria-describedby="discount"
                  type="text"
                  aria-label="deconto em porcentagem"
                  v-model="valueDiscount"
                  v-mask="'##'"
                >
                <span
                  v-if="swicthDiscount && swicthMethodPayment"
                  class="input-group-text"
                  id="discount"
                >%</span>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="paymentType == 5">
            <b-col cols="12">
              <label class="fs-20">Descrição do pagamento: (Opcional)</label>
              <input type="text" class="form-control" v-model="descPagamento" placeholder="Ex: Pagamento na entrega pix e dinheiro e na loja pix, dinheiro e cartão.">
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-button 
                @click="sendPayment()"
                class="mt-2"
                block
                variant="success"
                >Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" sm="12" md="12" lg="6" xl="6">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Tarifas por transação em seu plano:</th>
                <th scope="col">Retire seu dinheiro em:</th>
                <th scope="col" v-if="information"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div v-html="details"></div>
                </td>
                <td>
                  <div v-if="getMoneyInXDays > 0" class="font-weight-bold">{{ getMoneyInXDays }} dia(s)</div>
                  <div v-else class="font-weight-bold">{{ getMoneyInXDays }}</div>
                </td>
                <td v-if="information">
                  <div v-html="information"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>

    </b-card>
  </b-overlay>
</template>

<script>
import makeToast from '@/mixins/makeToast';

export default {
  name: 'PaymentMethodCard',
  emits: ['paymentChange', 'selectCredit'],
  mixins: [makeToast],
  props: {
    name: {
      type: String,
      required: true,
    },
    getMoneyInXDays: {
      type: Number | String,
      required: false,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    details: {
      type: String,
      required: false,
    },
    information: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      require: false,
      default: false,
    },
    discount: {
      type: Number,
      require: false,
      default: 0,
    },
    enabledDiscount: {
      type: Boolean,
      required: true,
    },
    descricao: {
      type: String,
      default: '',
      required: false,
    },
    paymentType: {
      type: Number | String,
      required: true,
    },
  },

  data() {
    return {
      swicthMethodPayment: false,
      swicthDiscount: false,
      valueDiscount: 0,
      descPagamento: '',
    }
  },

  mounted (){
    setTimeout(() => {
      this.swicthMethodPayment = this.enabled;
      this.swicthDiscount = this.enabledDiscount;
      this.valueDiscount = this.discount;
      this.descPagamento = this.descricao;
    }, 100);
  },

  methods: {
    sendPayment(){
      if(this.swicthDiscount == true && this.valueDiscount == 0){
        this.makeToast('Erro', 'Favor inserir um valor maior que 0(zero) para o desconto', 'danger');
        return
      }
      this.$emit('paymentChange', this.swicthMethodPayment, this.valueDiscount, this.descPagamento)
    },
    discountEnable(){
      this.swicthDiscount = !this.swicthDiscount;
      if(this.swicthDiscount == false) {
        this.valueDiscount = 0
      }
    },
    paymentEnable(){
      this.swicthMethodPayment = !this.swicthMethodPayment;
      this.swicthDiscount = false;
      if(this.swicthMethodPayment == false || this.swicthDiscount == false) {
        this.valueDiscount = 0
      }
      
      this.$emit('selectCredit', this.swicthMethodPayment)
    }
  }

};
</script>

<style scoped>
.input-width{
  width: 100px;
}
</style>